module.exports = __webpack_public_path__ + "static/media/TripleVibe.1a593058.mp3";